import { Fragment, ReactNode } from "react";
import { TypographyComponent } from "../../gravity/typography/typography.component";
import { t } from "i18next";
import { TertiaryButtonComponent } from "../../gravity/buttons/tertiary/tertiary-button.component";
import { WarningIcon } from "../../../icons/warning.icon";
import { SuccessCircleIcon } from "../../../icons/success-circle.icon";
import { InfoIcon } from "../../../icons/info.icon";
import classNames from "classnames";
import styles from "./sticky-header-banner.styles.module.scss";

type StickyHeaderBannerProps = {
  variant: "informative" | "error" | "warning" | "success";
  messageStartIcon?: ReactNode;
  message: string;
  CTALabel: string;
  CTAStartIcon?: ReactNode;
  CTAEndIcon?: ReactNode;
  onCTAClick?: () => void;
  noBorderRadius?: boolean;
  boxShadow?: boolean;
};

/** @deprecated does not conform to any gravity component, shall not be used in new designs */
export const StickyHeaderBanner = ({
  variant,
  messageStartIcon = null,
  message,
  CTALabel,
  CTAStartIcon = null,
  CTAEndIcon = null,
  onCTAClick = () => {},
  noBorderRadius = false,
  boxShadow = false
}: StickyHeaderBannerProps) => {
  return (
    <div
      className={classNames(styles.root, {
        [styles.bannerInformative]: variant==="informative",
        [styles.bannerError]: variant==="error",
        [styles.bannerWarning]: variant==="warning",
        [styles.bannerSuccess]: variant === "success",
        [styles.noBorderRadius]: noBorderRadius,
        [styles.boxShadow]: boxShadow
      })}
    >
      <div className={styles.container}>
        <div className={styles.messageSection}>
          {messageStartIcon || {
            informative: <InfoIcon />,
            error: <InfoIcon />,
            warning: <WarningIcon />,
            success: <SuccessCircleIcon />
          }[variant] || <Fragment />}
          <TypographyComponent styling="p-sm" boldness="semi">{message}</TypographyComponent>
        </div>
        <TertiaryButtonComponent
          size={"small"}
          onClick={onCTAClick}
          theme={"light"}
          startIcon={CTAStartIcon}
          endIcon={CTAEndIcon}
        >
          {t(CTALabel)}
        </TertiaryButtonComponent>
      </div>
    </div>
  );
};
